import * as React from 'react';
import { IconProps } from '../types';

const IcMenuChange = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M7.198 6.695a7.46 7.46 0 0 1 3.944-2.073l-.36-1.967a9.5 9.5 0 0 0-4.998 16.061l-1.707 1.707h4.828v-4.828l-1.707 1.707a7.5 7.5 0 0 1 0-10.607Zm13.726-3.12h-4.828v4.83l1.707-1.708a7.5 7.5 0 0 1-3.944 12.68l.36 1.967a9.5 9.5 0 0 0 4.998-16.061l1.707-1.707Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcMenuChange;
